/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



function addorremove(checkbox) {
    var variantId = checkbox.getAttribute('data-variant-id');

    if (checkbox.checked) {
      var formData = new FormData();

      formData.append("id", variantId);  // Set the product ID
      formData.append("quantity", "1");
      window.cart.addToCart(formData);
      // addVariantToCart(variantId);
    } else {
      $('[data-item-title="Shipping Protection"] .cart__item__remove span').click()
    }
}

function addVariantToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        }),
    }).then(response => response.json()).then(data => {
        document.getElementById('shipping-protection').checked = true;
       location.reload();
              

    }
    ).catch(error => {
        console.error('Error adding variant to cart:', error);
    }
    );
}

function removeVariantFromCart(variantId) {
    fetch('/cart.js').then(response => response.json()).then(cart => {
        const lineItem = cart.items.find(item => item.variant_id === parseInt(variantId));
        if (lineItem) {
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: lineItem.id.toString(),
                    quantity: 0
                }),
            }).then(response => response.json()).then(data => {
             location.reload();
              

            }
            ).catch(error => {
                console.error('Error removing variant from cart:', error);
            }
            );
        } else {
            console.error('Variant not found in cart.');
        }
    }
    ).catch(error => {
        console.error('Error fetching cart:', error);
    }
    );
}

